import Head from "next/head";
import React, { FC } from "react";
import { WpYoastHead } from "types/wp-yoast-head";

interface HeadTagsRendererProps {
  yoastJson: WpYoastHead;
}

const HeadTagsRenderer: FC<HeadTagsRendererProps> = ({ yoastJson }) => {
  return (
    <Head>
      <title>{yoastJson?.title || ""}</title>
      <meta name="description" content={yoastJson?.description || ""} />
      <link rel="canonical" href={yoastJson?.canonical || ""} />
      <meta
        name="robots"
        content={`${yoastJson?.robots?.index || ""}, ${
          yoastJson?.robots?.follow
        }, ${yoastJson?.robots?.["max-snippet"] || ""}, ${
          yoastJson?.robots?.["max-image-preview"] || ""
        }, ${yoastJson?.robots?.["max-video-preview"]}`}
      />
      <meta property="og:locale" content={yoastJson?.og_locale || "en_US"} />
      <meta property="og:type" content={yoastJson?.["og_type"] || "article"} />
      <meta property="og:title" content={yoastJson?.title || ""} />
      <meta
        property="og:url"
        content={yoastJson?.["og_url"] || "https://www.rockstarenergy.com"}
      />
      <meta property="og:site_name" content={yoastJson?.["og_site_name"]} />
      {yoastJson?.["article_modified_time"] && (
        <meta
          property="article:modified_time"
          content={yoastJson?.["article_modified_time"]}
        />
      )}
      {yoastJson?.["og_image"] && (
        <meta
          property="og:image"
          content={yoastJson?.["og_image"]?.[0]?.url || ""}
        />
      )}
      {yoastJson?.["og_image"] && (
        <meta
          property="og:image:width"
          content={yoastJson?.["og_image"]?.[0]?.width?.toString() || "0"}
        />
      )}
      {yoastJson?.["og_image"] && (
        <meta
          property="og:image:height"
          content={yoastJson?.["og_image"]?.[0]?.height?.toString() || "0"}
        />
      )}
      {yoastJson?.["og_image"] && (
        <meta
          property="og:image:type"
          content={yoastJson?.["og_image"]?.[0]?.type || "image/png"}
        />
      )}
      {yoastJson?.twitter_card && (
        <meta name="twitter:card" content={yoastJson?.twitter_card || ""} />
      )}
    </Head>
  );
};

export default HeadTagsRenderer;
